import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "page artist-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row row-eq-height" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "album-intro-card" }
const _hoisted_7 = { class: "artist-name-head" }
const _hoisted_8 = { class: "artist-name-alt" }
const _hoisted_9 = { class: "artist-name-alt" }
const _hoisted_10 = { class: "style-list" }
const _hoisted_11 = { class: "style-list" }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-danger mb-2"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-danger mb-2"
}
const _hoisted_14 = {
  key: 2,
  class: "album-year"
}
const _hoisted_15 = { class: "style-list" }
const _hoisted_16 = { class: "style-list" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "row mt-3" }
const _hoisted_21 = { class: "col-lg-8" }
const _hoisted_22 = {
  key: 0,
  class: "bg-white pt-3 pl-3 pr-3"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h2", null, "访谈/乐评", -1)
const _hoisted_24 = { class: "artist-albums mt-3" }
const _hoisted_25 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_26 = { class: "link-list info-box" }
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "info-box" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "info-box" }
const _hoisted_31 = { class: "info-box" }
const _hoisted_32 = { class: "info-box" }
const _hoisted_33 = { class: "info-box" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "info-box mt-3"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h3", null, "评论区", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageWall = _resolveComponent("ImageWall")!
  const _component_StyleTag = _resolveComponent("StyleTag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArticleListItem = _resolveComponent("ArticleListItem")!
  const _component_MetaArtistTab = _resolveComponent("MetaArtistTab")!
  const _component_MetaArtistAlbum = _resolveComponent("MetaArtistAlbum")!
  const _component_UserTag = _resolveComponent("UserTag")!
  const _component_CommentList = _resolveComponent("CommentList")!
  const _component_ArtistEditor = _resolveComponent("ArtistEditor")!
  const _component_AlbumEdit = _resolveComponent("AlbumEdit")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_wechat_title = _resolveDirective("wechat-title")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.info.images.length > 0)
              ? (_openBlock(), _createBlock(_component_ImageWall, {
                  key: 0,
                  images: _ctx.info.images
                }, null, 8, ["images"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.info.name) + " ", 1),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.info.name_roman), 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.info.name_cn_simp), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.namevariations, (name) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: name,
                        class: "member-name"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(name), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.info.type.index == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "艺人"))
                      : _createCommentVNode("", true),
                    (_ctx.info.type.index == 2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, "乐队/组合"))
                      : _createCommentVNode("", true),
                    (_ctx.info.begin_year)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, "[ " + _toDisplayString(_ctx.info.begin_year) + " - " + _toDisplayString(_ctx.info.end_year || "/") + " ]", 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.styles, (style) => {
                      return (_openBlock(), _createBlock(_component_StyleTag, {
                        key: style._id,
                        genre: style,
                        full: 0,
                        hot: style.hot_index
                      }, null, 8, ["genre", "hot"]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.relate_styles, (style) => {
                      return (_openBlock(), _createBlock(_component_StyleTag, {
                        key: style._id,
                        genre: style,
                        full: 0
                      }, null, 8, ["genre"]))
                    }), 128))
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.classical_members, (cm, k) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: k,
                      class: "style-list"
                    }, " 经典阵容 " + _toDisplayString(cm), 1))
                  }), 128)),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.groups, (member) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: member.id,
                        class: _normalizeClass(["member-name", { 'member-name-leave': !member.active }])
                      }, [
                        (member._id)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { path: '/meta/artist/' + member._id }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(member.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(member.name), 1))
                      ], 2))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.members, (member) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: member.id,
                        class: _normalizeClass(["member-name", { 'member-name-leave': !member.active }])
                      }, [
                        (member._id)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: { path: '/meta/artist/' + member._id }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(member.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(member.name), 1))
                      ], 2))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    class: "profile-info info-holder",
                    innerHTML: _ctx.markdown.render(_ctx.info.profile)
                  }, null, 8, _hoisted_19)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          (_ctx.articles.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _hoisted_23,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.articles, (article_info) => {
                  return (_openBlock(), _createBlock(_component_ArticleListItem, {
                    key: article_info._id,
                    article: article_info,
                    full: 1,
                    "show-album": true,
                    position: "meta-artist"
                  }, null, 8, ["article"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_MetaArtistTab, {
            modelValue: _ctx.activeAlbumType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeAlbumType) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albums[_ctx.activeAlbumType], (album) => {
              return (_openBlock(), _createBlock(_component_MetaArtistAlbum, {
                key: album._id,
                album: album
              }, null, 8, ["album"]))
            }), 128))
          ])
        ]),
        (_ctx.info)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.links, (link) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: (link as any)._id,
                    class: "link-outside"
                  }, [
                    _createElementVNode("a", {
                      href: link.url,
                      target: "_blank"
                    }, [
                      _createElementVNode("b", null, "[ " + _toDisplayString(link.site) + " ]", 1)
                    ], 8, _hoisted_27)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.online_links, (link, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    class: "link-outside link-online"
                  }, [
                    _createElementVNode("a", {
                      href: link.url,
                      target: "_blank"
                    }, _toDisplayString(_ctx.online_link_name[index]), 9, _hoisted_29)
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_30, "数据品质：" + _toDisplayString(_ctx.info.quality.name), 1),
              _createElementVNode("div", _hoisted_31, [
                (_ctx.userInfo.type.index >= 1 && _ctx.info.quality.index < 2)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success mr-3",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showEditer && _ctx.showEditer(...args)))
                    }, "编辑"))
                  : _createCommentVNode("", true),
                (_ctx.userInfo.type.index >= 2 && _ctx.info.quality.index === 1)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success mr-3",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doLockInfo && _ctx.doLockInfo(...args)))
                    }, "锁定"))
                  : _createCommentVNode("", true),
                (_ctx.userInfo.type.index >= 1 && _ctx.info.quality.index == 1)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogFormAlbumVisible = true))
                    }, "添加专辑"))
                  : _createCommentVNode("", true),
                (_ctx.userInfo.type.index >= 1 && _ctx.info.quality.index == 1)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleShowThirdEditor && _ctx.handleShowThirdEditor(...args)))
                    }, "添加Discogs/网易专辑"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createTextVNode(" 数据整理： "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.info.contribute_user, (user) => {
                  return (_openBlock(), _createBlock(_component_UserTag, {
                    key: user._id,
                    user: user,
                    full: 1
                  }, null, 8, ["user"]))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                (_ctx.userInfo.type.index >= 1)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn btn-outline-success",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handlerCreateArticle && _ctx.handlerCreateArticle(...args)))
                    }, "乐评/访谈"))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.userInfo.userId && _ctx.info)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_CommentList, {
                      "target-type": "ARTIST",
                      "target-id": _ctx.id,
                      "comment-info": {
                                artist_id: _ctx.id,
                            }
                    }, null, 8, ["target-id", "comment-info"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_ArtistEditor, {
      id: _ctx.id,
      visible: _ctx.dialogFormVisible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      "is-keep-url": true,
      onChange: _ctx.refresh
    }, null, 8, ["id", "visible", "onChange"]),
    _createVNode(_component_AlbumEdit, {
      ref: "albumEditor",
      visible: _ctx.dialogFormAlbumVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogFormAlbumVisible) = $event)),
      artist: _ctx.id,
      "is-keep-url": false,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogFormAlbumVisible = false)),
      onChange: _ctx.refresh
    }, null, 8, ["visible", "artist", "onChange"])
  ])), [
    [_directive_wechat_title, _ctx.info ? _ctx.info.name + ' - ' + _ctx.route.meta.title : undefined]
  ])
}